import { type TypedDocumentNode, gql } from '@apollo/client';
import { faClock } from '@fortawesome/pro-solid-svg-icons';
import { isFuture } from 'date-fns';
import { FormattedTime } from 'react-intl';

import { ManagerProgressionTaskState } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { ShortTimeLeft } from '@sorare/core/src/contexts/ticker/ShortTimeLeft';

import type { MissionTimeLeft_managerProgressionMission } from './__generated__/index.graphql';

type Props = {
  mission: MissionTimeLeft_managerProgressionMission;
};

export const MissionTimeLeft = ({ mission }: Props) => {
  if (
    mission.aasmState !== ManagerProgressionTaskState.READY ||
    !mission.claimableAt ||
    !isFuture(mission.claimableAt)
  ) {
    return null;
  }
  return (
    <Tooltip
      title={
        <FormattedTime
          dateStyle="short"
          day="numeric"
          month="short"
          year="numeric"
          value={mission.claimableAt}
        />
      }
    >
      <Horizontal gap={0.5}>
        <FontAwesomeIcon
          icon={faClock}
          color="var(--c-rivals-friendlies)"
          size="sm"
        />
        <LabelS color="var(--c-rivals-friendlies)" bold>
          <ShortTimeLeft time={mission?.claimableAt} />
        </LabelS>
      </Horizontal>
    </Tooltip>
  );
};

MissionTimeLeft.fragments = {
  managerProgressionMission: gql`
    fragment MissionTimeLeft_managerProgressionMission on ManagerProgressionMission {
      id
      claimableAt
      aasmState
    }
  ` as TypedDocumentNode<MissionTimeLeft_managerProgressionMission>,
};
